import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';

import { ToastComponent, ToasterService, ToastHeaderComponent, ToastBodyComponent, ToastCloseDirective, ProgressBarDirective, ProgressComponent } from '@coreui/angular-pro';
import { cilWarning } from '@coreui/icons';
import { freeSet } from '@coreui/icons';
import { IconDirective } from '@coreui/icons-angular'; 

@Component({
    selector: 'app-toast-simple',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    providers: [{ provide: ToastComponent, useExisting: forwardRef(() => AppToastComponent) }],
    standalone: true,
    imports: [ToastHeaderComponent, ToastBodyComponent, ToastCloseDirective,IconDirective, ProgressBarDirective, ProgressComponent]
})
export class AppToastComponent extends ToastComponent {
  icons = freeSet ;

  @Input() closeButton = true;
  @Input() title = '';
  @Input() description = '';
  @Input() status = true;
  
  constructor(
    public override hostElement: ElementRef,
    public override renderer: Renderer2,
    public override toasterService: ToasterService,
    public override changeDetectorRef: ChangeDetectorRef
  ) {
    super(hostElement, renderer, toasterService, changeDetectorRef);
  }
}
